<template>
  <div class="form__input" :class="{ 'form__input--error': !!error }">
    <label if="label" :for="id">
      {{ label }}
    </label>
    <input
      :id="id"
      v-model="displayValue"
      :type="type"
      :class="inputClasses"
      v-bind="$attrs"
      placeholder="(123) 456-7890"
      @input="handleInput"
      @blur="$emit('blur')"
    />
    <p v-show="error" :class="errorClasses">
      {{ error }}
    </p>
  </div>
</template>

  <script>
  export default {
    $_veeValidate: {
    name() {
      return this.label;
    },
    value() {
      return this.value;
    }
  },
    props: {
      id: {
        type: String,
        required: true
      },
      type: {
        type: String,
        default: 'text'
      },
      value: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      error: {
        type: String,
        default: null
      },
      labelClass: {
        type: [String, Array, Object],
        default: () => {}
      },
      inputClass: {
        type: [String, Array, Object],
        default: () => {}
      },
      errorClass: {
        type: [String, Array, Object],
        default: () => {}
      },
      tooltip: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        displayValue: this.formatPhoneNumber(this.value),
      };
    },

    computed: {
      inputClasses() {
        return {
          input: true,
          input__error: !!this.error,
          'has-input': this.displayValue !== '',
          ...this.inputClass
        };
      },
      errorClasses() {
        return {
          form__error: true,
          ...this.errorClass
        };
      }
    },

    watch: {
      value(newValue) {
        this.displayValue = this.formatPhoneNumber(newValue);
      }
    },

    methods: {
      formatPhoneNumber(value) {
        const numbers = value.replace(/\D/g, '').slice(0, 10); // Limit to 10 digits
        let formattedNumber = '';

        if (numbers.length > 0) {
          formattedNumber += `(${numbers.substring(0, 3)}`;
        }
        if (numbers.length >= 4) {
          formattedNumber += `) ${numbers.substring(3, 6)}`;
        }
        if (numbers.length >= 7) {
          formattedNumber += `-${numbers.substring(6, 10)}`;
        }

        return formattedNumber;
      },
      handleInput(event) {
        const rawValue = event.target.value.replace(/\D/g, '').slice(0, 10); // Enforce 10 digits limit
        this.displayValue = this.formatPhoneNumber(rawValue); // Update display with formatted value
        this.$emit('input', rawValue); // Emit raw value
      }
    }
  };
  </script>

  <style lang="scss" scoped>
  input {
    &::placeholder {
      color: white;
      opacity: 0.4;
    }
    &:-ms-input-placeholder {
      color: white;
      opacity: 0.4;
    }
    &::-ms-input-placeholder {
      color: white;
      opacity: 0.4;
    }
  }
  </style>
